import { createAsyncThunk } from '@reduxjs/toolkit'
import { getClientsReportService } from 'network/services/reports/clientsReport.service'

export const fetchAllClientsReport = createAsyncThunk(
  'fetch/allClientsReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getClientsReportService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
